<template>
  <v-dialog
    :value="dialog"
    max-width="600px"
    lazy
    persistent
    @input="$emit('close')"
  >
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>
          {{ $tc('models.user') }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form autocomplete="off">
          <h3 v-if="isPlayer">
            {{ $tc('titles.global.player') }}
          </h3>

          <v-layout row wrap mb-3>
            <v-flex md6 sm6 xs12 px-2>
              <v-text-field
                v-model="localItem.name"
                v-validate="'required'"
                :label="$t('fields.global.name') + ' (*)'"
                :data-vv-name="$t('fields.global.name')"
                :error-messages="errors.collect($t('fields.global.name'))"
                autocomplete="new-text"
                browser-autocomplete
                autofocus
              />
            </v-flex>
            <v-flex md6 sm6 xs12 px-2>
              <v-text-field
                v-model="localItem.lastname1"
                v-validate="'required'"
                :label="$t('fields.users.lastname') + ' (*)'"
                :data-vv-name="$t('fields.users.lastname')"
                :error-messages="errors.collect($t('fields.users.lastname'))"
                autocomplete="new-text"
                browser-autocomplete
              />
            </v-flex>
            <v-flex md6 sm6 xs12 px-2>
              <v-text-field
                v-model="localItem.lastname2"
                :label="$t('fields.users.lastname2')"
                autocomplete="new-text"
                browser-autocomplete
              />
            </v-flex>

            <v-flex md6 sm6 xs12 px-2>
              <v-select
                v-model="localItem.gender"
                v-validate="'required'"
                :items="genders"
                :label="$t('fields.users.sex') + ' (*)'"
                :data-vv-name="$t('fields.users.sex')"
                :error-messages="errors.collect($t('fields.users.sex'))"
                @focus="(e) => e.target.click()"
              />
            </v-flex>
            <v-flex md6 sm6 xs12 px-2>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                transition="scale-transition"
              >
                <v-text-field
                  slot="activator"
                  v-model="birthdayDate"
                  v-validate="'required'"
                  :label="$t('fields.users.birthdayDate') + ' (*)'"
                  readonly
                  :data-vv-name="$tc('fields.users.birthdayDate')"
                  :error-messages="
                    errors.collect($tc('fields.users.birthdayDate'))
                  "
                />
                <v-date-picker
                  ref="picker1"
                  v-model="localItem.birthdayDate"
                  min="1930-01-01"
                  :max="new Date().toISOString().split('T')[0]"
                  first-day-of-week="1"
                  :locale="$store.state.languages.iso()"
                >
                  <v-spacer />
                  <v-btn flat color="primary" @click="menu1 = false">
                    {{ $t('action.buttons.cancel') }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.menu1.save(birthdayDate)"
                  >
                    {{ $t('action.buttons.save') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6 sm6 xs12 px-2>
              <v-text-field
                v-model="localItem.email"
                v-validate="'required|email'"
                :label="$t('fields.users.email') + ' (*)'"
                :data-vv-name="$t('fields.users.email')"
                :error-messages="[
                  ...errors.collect($t('fields.users.email')),
                  ...(emailAlreadyRegisted
                    ? [$t('error.error.emailAlreadyRegisted')]
                    : []),
                ]"
                autocomplete="new-text"
                browser-autocomplete
                :loading="loadingEmail"
                @change="onChangeEmail($event, 'user')"
                @keyup.enter="() => !isPlayer && submit()"
              />
            </v-flex>
          </v-layout>
          <template v-if="isPlayer">
            <h3>{{ $t('titles.global.familiar') }}</h3>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12 px-2>
                <v-text-field
                  v-model="localItem.name_familiar"
                  v-validate="'required'"
                  :label="$t('fields.global.name') + ' (*)'"
                  :data-vv-name="$t('fields.global.name') + '.'"
                  :error-messages="
                    errors.collect($t('fields.global.name') + '.')
                  "
                  autocomplete="new-text"
                  browser-autocomplete
                />
              </v-flex>
              <v-flex md6 sm6 xs12 px-2>
                <v-text-field
                  v-model="localItem.lastname1_familiar"
                  v-validate="'required'"
                  :label="$t('fields.users.lastname') + ' (*)'"
                  :data-vv-name="$t('fields.users.lastname') + '.'"
                  :error-messages="
                    errors.collect($t('fields.users.lastname') + '.')
                  "
                  autocomplete="new-text"
                  browser-autocomplete
                />
              </v-flex>
              <v-flex md6 sm6 xs12 px-2>
                <v-text-field
                  v-model="localItem.lastname2_familiar"
                  :label="$t('fields.users.lastname2')"
                  autocomplete="new-text"
                  browser-autocomplete
                />
              </v-flex>

              <v-flex md6 sm6 xs12 px-2>
                <v-select
                  v-model="localItem.gender_familiar"
                  v-validate="'required'"
                  :items="genders"
                  :label="$t('fields.users.sex') + ' (*)'"
                  :data-vv-name="$t('fields.users.sex') + '.'"
                  :error-messages="errors.collect($t('fields.users.sex') + '.')"
                  @focus="(e) => e.target.click()"
                />
              </v-flex>
              <v-flex md6 sm6 xs12 px-2>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  full-width
                  lazy
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                >
                  <v-text-field
                    slot="activator"
                    v-model="familiarBirthdayDate"
                    v-validate="'required'"
                    :label="$t('fields.users.birthdayDate') + ' (*)'"
                    readonly
                    :data-vv-name="$tc('fields.users.birthdayDate') + '.'"
                    :error-messages="
                      errors.collect($tc('fields.users.birthdayDate') + '.')
                    "
                  />
                  <v-date-picker
                    ref="picker2"
                    v-model="localItem.birthdayDate_familiar"
                    min="1930-01-01"
                    :max="new Date().toISOString().split('T')[0]"
                    first-day-of-week="1"
                    :locale="$store.state.languages.iso()"
                  >
                    <v-spacer />
                    <v-btn flat color="primary" @click="menu2 = false">
                      {{ $t('action.buttons.cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.menu2.save(familiarBirthdayDate)"
                    >
                      {{ $t('action.buttons.save') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md6 sm6 xs12 px-2>
                <v-text-field
                  v-model="localItem.email_familiar"
                  v-validate="{
                    required: true,
                    email: true,
                    is_not: localItem.email,
                  }"
                  :label="$t('fields.users.email') + ' (*)'"
                  :data-vv-name="$t('fields.users.email') + '.'"
                  :error-messages="[
                    ...errors.collect($t('fields.users.email') + '.'),
                    ...(familiarEmailAlreadyRegisted
                      ? [$t('error.error.emailAlreadyRegisted')]
                      : []),
                  ]"
                  autocomplete="new-text"
                  browser-autocomplete
                  :loading="loadingEmail"
                  @change="onChangeEmail($event, 'familiar')"
                  @keyup.enter="submit"
                />
              </v-flex>
            </v-layout>
          </template>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="$emit('close')" />

        <v-btn small color="primary" @click="submit">
          {{ $t('action.buttons.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vuetifyToast from 'vuetify-toast'
import { mapGetters } from 'vuex'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

export default {
  name: 'UsersBulkCreateForm',
  props: {
    item: { type: Object, require: true },
    isPlayer: { Type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      menu1: false,
      menu2: false,
      loadingEmail: false,
      emailAlreadyRegisted: false,
      familiarEmailAlreadyRegisted: false,
    }
  },
  computed: {
    ...mapGetters({
      genders: 'users/genders',
    }),
    localItem: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('update:item', val)
      },
    },
    birthdayDate() {
      return formatDate(this.localItem.birthdayDate)
    },
    familiarBirthdayDate() {
      return formatDate(this.localItem.birthdayDate_familiar)
    },
  },
  watch: {
    menu1(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.picker1) this.$refs.picker1.activePicker = 'YEAR'
        })
      }
    },
    menu2(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.picker2) this.$refs.picker2.activePicker = 'YEAR'
        })
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.dialog = true
    }, 100)
  },
  methods: {
    async submit() {
      const isValid = await this.validate()
      if (
        isValid &&
        !this.emailAlreadyRegisted &&
        !this.familiarEmailAlreadyRegisted
      ) {
        this.$emit('submit')
      }
    },
    onChangeEmail(email, type) {
      this.loadingEmail = true
      if (type === 'user') this.emailAlreadyRegisted = false
      else this.familiarEmailAlreadyRegisted = false

      apiAxios
        .post('users/simplified', { email })
        .then(({ data }) => {
          if (data.data && data.data.user && data.data.user.length > 0) {
            if (type === 'user') this.emailAlreadyRegisted = true
            else this.familiarEmailAlreadyRegisted = true
          }

          if (
            (type === 'user' && this.emailAlreadyRegisted) ||
            (type === 'familiar' && this.familiarEmailAlreadyRegisted)
          ) {
            vuetifyToast.show({
              text: this.$t('error.error.emailAlreadyRegisted'),
              color: 'error',
              timeout: 2000,
              icon: 'warning',
            })
          }
        })
        .finally(() => {
          this.loadingEmail = false
        })
    },
  },
}
</script>

<style></style>
